const LOCAL_STORAGE_KEYS = {
  tokens: 'tokens',
  redirectUrl: 'redirectUrl',
  goBackUrl: 'goBackUrl'
};

export default LOCAL_STORAGE_KEYS;
